<template>
  <component
    :is="component"
    class="editor-link"
    v-bind="attributes"
    @click="onClick"
  >
    <slot></slot>
  </component>
</template>

<script>
import smoothScroll from '@/helpers/smoothScroll';

export default {
  name: 'EditorLink',
  props: {
    model: {
      type: [String, Object],
      default: '',
    },
  },
  computed: {
    pages() {
      return this.$store?.getters.pagesArray() || [];
    },
    attributes() {
      if (typeof this.model === 'undefined') {
        return {
          href: '',
        };
      }

      if (typeof this.model === 'string') {
        return {
          href: this.checkLetsbookLink(this.model),
          target: this.target,
        };
      }

      if (this.model.type === 'externalLink') {
        return {
          href: this.checkLetsbookLink(this.model.value),
          target: this.target,
        };
      }

      if (this.isAnchoring && this.model.value.page === '') {
        return {
          href: this.model.value.anchor,
        };
      }

      if (this.model.type === 'file') {
        return {
          href: this.model.value,
          target: this.target,
        };
      }

      const pageId = this.model.value.page ?? this.model.value;
      const page = this.pages.find((innerPage) => innerPage.id === pageId);

      if (!page) {
        return {
          href: '',
        };
      }

      const { language = 'pt', urlPath = '' } = page || {};

      const hash =
        typeof this.model.value !== 'string' ? this.model.value.anchor : '';

      const query = {};

      if (hash) {
        query.hash = hash;
      }

      const { href } = this.$router.resolve({
        name: 'preview',
        params: { language, urlPath },
        query,
      });

      return {
        href,
        target: this.target,
      };
    },
    component() {
      return this.attributes.href?.trim() ? 'a' : 'span';
    },
    target() {
      return typeof this.model === 'string' || this.model.openInNewTab
        ? '_blank'
        : '_self';
    },
    isAnchoring() {
      return (
        this.model.type === 'anchor' &&
        (this.model.value.page === this.$store.state.activePageId ||
          this.model.value.page === '')
      );
    },
    apiLocale() {
      switch (this.$i18n.locale) {
        case 'en':
          return 'en-us';
        case 'es':
          return 'es-es';
        default:
          return 'pt-br';
      }
    },
  },
  methods: {
    onClick(event) {
      if (this.isAnchoring) {
        event.preventDefault();

        this.$emit('anchoring');

        const anchorId = this.model.value.anchor;

        smoothScroll(anchorId);
      }
    },
    formatDate(date) {
      const [day, month, year] = date.split('/');
      return `${year}-${month}-${day}`;
    },
    checkLetsbookLink(link) {
      if (!link) {
        return '';
      }

      try {
        const url = new URL(link);

        if (url.hostname.includes('.letsbook.com.br')) {
          const pathReplacements = [
            { regex: /^\/D(\/Busca)?\/?$/i, replace: '/reserva/busca' },
            {
              regex: /^\/D\/Compras\/?$/i,
              replace: '/reserva/minhas-reservas',
            },
            {
              regex: /^\/D\/Reserva\/?$/i,
              replace: '/reserva/selecao-de-quartos',
            },
          ];

          const replaced = pathReplacements.find(({ regex }) =>
            regex.test(url.pathname),
          );

          if (replaced) {
            url.pathname = replaced.replace;

            ['checkin', 'checkout'].forEach((dateParam) => {
              const date = url.searchParams.get(dateParam);
              if (date) {
                url.searchParams.set(dateParam, this.formatDate(date));
              }
            });
          }

          return url.toString();
        }

        return link;
      } catch (err) {
        return link;
      }
    },
  },
};
</script>
